/**
 * Tables inside an actor database that are not part of the app's schema: the migration journal,
 * the sync engine's upload cursors and the tables the server keeps in every cloud copy (see
 * `database.md`, "Server: cloud schema service"). A replica receives them from the cloud copy like
 * any other table. No app migration and no app statement may write them.
 */
export const ACTOR_SYNC_INTERNAL_TABLES: readonly string[] = [
  "__drizzle_migrations",
  "__haniverse_applied_writes",
  "haniverse_sync_dead_letter",
  "haniverse_sync_guard",
  "haniverse_sync_imports",
  "haniverse_sync_meta",
  "turso_sync_last_change_id",
];

const ENGINE_TABLE_PREFIXES = ["sqlite_", "turso_", "__turso_"] as const;

/** Whether `name` is one of the app's own tables, as opposed to bookkeeping of any kind. */
export function isActorAppTableName(name: string): boolean {
  return (
    !ACTOR_SYNC_INTERNAL_TABLES.includes(name) &&
    !ENGINE_TABLE_PREFIXES.some((prefix) => name.startsWith(prefix))
  );
}
